import { useState } from "react";
import { Button, Icon } from "@chakra-ui/react";
import { MdArrowForward } from "react-icons/md";
import { FragmentType, getFragmentData, gql } from "__generated__/gql";
import { serverGql } from "__generated__/serverGql";
import useAsyncCompleteToast from "components/Shared/useAsyncCompleteToast";
import serverClient from "utils/apollo/serverClient";
import { assertPresence } from "utils/assertions";
import { BRAND_BILLING } from "utils/links";

const fragment = gql(/* GraphQL */ `
  fragment StartSubscriptionButton on Brand {
    id
    stripeCustomerId
    stripePriceId
  }
`);

const mutation = serverGql(/* ServerGraphQL */ `
  mutation CreateStripeCheckoutSession($brandId: UUID!, $successUrl: String!, $cancelUrl: String!) {
    createStripeCheckoutSession(brandId: $brandId, successUrl: $successUrl, cancelUrl: $cancelUrl) {
      url
    }
  }
`);

type Props = {
  brand: FragmentType<typeof fragment>;
};

export default function StartSubscriptionButton({
  brand: brandFragment,
}: Props) {
  const brand = getFragmentData(fragment, brandFragment);

  const [isLoading, setIsLoading] = useState(false);

  const { showErrorToast } = useAsyncCompleteToast();

  const handleClick = () => {
    setIsLoading(true);

    const baseUrl = window.location.origin;
    const successUrl = `${baseUrl}${BRAND_BILLING}`;
    const cancelUrl = `${baseUrl}${BRAND_BILLING}`;

    serverClient
      .mutate({
        mutation,
        variables: {
          brandId: brand.id,
          successUrl,
          cancelUrl,
        },
      })
      .then((response) => {
        const url = response.data?.createStripeCheckoutSession?.url;
        assertPresence(url, "Expected checkout URL to be defined");
        window.location.href = url;
      })
      .catch((reason: unknown) => {
        showErrorToast(reason);
        setIsLoading(false);
      });
  };

  return (
    <Button
      colorScheme="pinkButton"
      isDisabled={!brand?.stripeCustomerId || !brand?.stripePriceId}
      isLoading={isLoading}
      onClick={handleClick}
      rightIcon={<Icon as={MdArrowForward} mr={-2} />}
      mb={6}
    >
      Start Subscription
    </Button>
  );
}
